import { Change } from "../global/interfaces/Change";
import { Contact } from "../pages/Contacts/interfaces/Contact";
import {groupBy} from "lodash"

const parseName = (name: string): { vorname: string; nachname: string; namensZusatz: string } => {
  const nameParts = name.split(" ");

  let vorname = "";
  let nachname = "";
  let namensZusatz = "";

  if (nameParts.length >= 2) {
    nachname = nameParts[0];
    vorname = nameParts[1];
  }

  if (nameParts.length > 2) {
    namensZusatz = nameParts.slice(2).join(" ");
  }

  return { vorname, nachname, namensZusatz };
};

const createContactFromChange = (change: Change): Contact => {
  const { vorname, nachname, namensZusatz } = parseName(change.name!);

  return {
    suchname: change.suchname!,
    name: change.name!,
    vorname,
    nachname,
    namensZusatz,
    [change.feld as string]: change.wertAenderung,
    // Initialize the rest of the fields with some default values
    titel: "",
    nachgestellterTitel: "",
  };
};

const mergeChangeWithContact = (contact: Contact, change: Change): Contact => ({
  ...contact,
  [change.feld]: change.wertAenderung,
});

export const mergeChangesWithContacts = (
  contacts: Contact[],
  changes: Change[]
): Contact[] => {
  // Separate changes into delete changes and other changes
  const deleteChanges = changes.filter(change => change.feld === "_delete");
  const otherChanges = changes.filter(change => change.feld !== "_delete");

  // Filter out contacts that match a delete change
  let updatedContacts = contacts.filter(
    contact => !deleteChanges.some(change => change.suchname === contact.suchname && change.name === contact.name)
  );

  // Apply other changes to remaining contacts
  updatedContacts = updatedContacts.map(contact => {
    const matchingChange = otherChanges.find(
      change => change.suchname === contact.suchname && change.name === contact.name
    );

    return matchingChange
      ? mergeChangeWithContact(contact, matchingChange)
      : contact;
  });

  // Group changes by suchname and name
  const changesGroupedByContact = groupBy(otherChanges, change => `${change.suchname}${change.name}`);

  const newContacts = Object.values(changesGroupedByContact).map(changes => {
    // Merge all changes into one change
    const mergedChange = changes.reduce((acc, change) => ({
      ...acc,
      [change.feld]: change.wertAenderung,
    }), {} as Change);
  
    // Use the first change to fill in the rest of the fields
    const firstChange = changes[0];
    mergedChange.suchname = firstChange.suchname;
    mergedChange.name = firstChange.name;
    mergedChange.datum = firstChange.datum;
    mergedChange.status = firstChange.status;
    mergedChange.id = firstChange.id;
  
    // Create a new contact using mergedChange
    const newContact = createContactFromChange(mergedChange);
  
    // Now add the properties of each change to the new contact
    changes.forEach(change => {
      newContact[change.feld as string] = change.wertAenderung;
    });
  
    return newContact;
  });
  

  return [...updatedContacts, ...newContacts];
};